export const getExpenseIncomeWarning = (monthlyIncome, monthlyExpenses) => {
  if (
    monthlyIncome === null ||
    monthlyIncome === undefined ||
    monthlyExpenses === null ||
    monthlyExpenses === undefined ||
    monthlyIncome <= 0
  ) {
    return null;
  }

  const expensePercentageOfIncome = monthlyExpenses / monthlyIncome;

  if (expensePercentageOfIncome > 1) {
    return {
      title: 'Your living and housing expenses are higher than your income.',
      message: 'Please review the amounts you’ve entered. If they’re correct, select Next to continue.',
      editButtonText: 'Edit',
    };
  }

  if (expensePercentageOfIncome >= 0.85) {
    return {
      title: 'Please review your monthly income and expenses',
      message: 'If they’re correct, select Next to continue.',
      editButtonText: 'Edit',
    };
  }

  return null;
};
